import React, { Component } from 'react';

import request from '@acri-tools/react-tools/utils/request';
import { API_URL, axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
// import { searchParamsQuery } from '@acri-tools/react-tools/utils/query';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { setGeneral } from '../../redux/actions';
import SearchForm from '@acri-tools/react-tools/components/Search/Search';

interface Props {
    history?: any,
    setGeneral?: Function
}

type SearchParams = {
    search: string
    orderby: string
    limit: string
    offset: string
    orderbyDirection: string
}

class DeletedAnomaliesSearch extends Component<Props, {}>{
    state = {
        count: 0,
        searchParams: {
            search: '',
            offset: '0',
            limit: '10',

            orderby: 'id',
            orderbyDirection: 'desc',
        },
        anomalies: [],
        filters: {
            "id": { active: true },
            "title": { active: true },
        },
        filterEnabled: false,

        anomaly: {},
        updateLoading: false,
        updateMessage: '',
        updateMessageType: 'error',
    }


    componentDidMount() {
        this.search();
    }

    render() {
        return (
            <>
                <div className="admin-form panel panel-full">
                    <div className="title-1">Search Deleted Anomalies</div>
                    <div className="subtitle-1">Search Deleted Anomalies using the following criteria</div>
                    <br />

                    <SearchForm orderby={['id', 'title']} count={this.state.count}
                        filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >
                        <div className="results">
                            <div className="results-table">
                                <table className="dark">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Creation Date</th>
                                            <th>Update Date</th>
                                            <th>Category</th>
                                            <th>NRT Status</th>
                                            <th>Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.anomalies &&
                                            this.state.anomalies.map((a: any, idx: number) => (
                                                <tr key={idx}>
                                                    <td>{a.id}</td>
                                                    <td>{a.title}</td>
                                                    <td>{a.type}</td>
                                                    <td>{a.creation_date}</td>
                                                    <td>{a.update_date}</td>
                                                    <td>{a.category}</td>
                                                    <td>{a.nrt_status}</td>
                                                    <td>
                                                        <div className="search-operations">
                                                            <div className="search-operation custom-button inverted alt icon-only" onClick={() => { this.revertDelete(a) }}>
                                                                <i className="fas fa-undo" />
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        RESTORE
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="search-operation custom-button inverted red alt icon-only" onClick={() => { this.delete(a.id) }}>
                                                                <i className="fas fa-times" />
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        DELETE
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SearchForm>

                </div>
            </>
        );
    }

    revertDelete = async (anomaly: any) => {
        if (window.confirm(`Are you sure you want to restore anomaly'${anomaly.id}' ?`)) {
            let data = { status: 'updated' };
            request(`${API_URL}/api/v1/anomalies/${anomaly.id}`, {
                method: 'put',
                responseType: 'json',
                serializer: 'json',
                data
            })
                .then((res: any) => {
                    this.search();
                    this.props.setGeneral?.({ isRestored: true });
                })
                .catch(e => {
                    axiosErrorHandler(e, {
                        functionName: 'restore',
                        requestName: 'restore_anomaly',
                    })
                })
        
        }
    }

    searchParamsQuery = (params: SearchParams, filters: any) => {
        let {
            search, limit, offset, orderby, orderbyDirection
        } = params
        let filter = [];
        let search_value = '';
        if (search) {
            for (let f of Object.keys(filters)) {
                if (filters[f].active) {
                    let column = filters[f].column ? filters[f].column : f;
                    filter.push(`${column}:varchar eq '${search}'`);
                }
            }
            if (filter.length > 0) {
                search_value = filter.join(' or ');
            }
            search_value = `( ${search_value} )`
        }

        if (search_value) {
            search_value += ' and ';
        }

        search_value += ` status eq 'deleted' `;

        return {
            filter: search_value ? `( ${search_value} )` : undefined,
            limit,
            offset,
            orderby: `${orderby} ${orderbyDirection}`,
        }
    }

    search = () => {
        this.setState({ loading: true });
        request(`${API_URL}/api/v1/anomalies`, {
            method: 'get',
            params: {
                ...this.searchParamsQuery(this.state.searchParams, this.state.filters),
                count: true
            },
        })
            .then((res: any) => {
                this.setState({ loading: false, anomalies: res.data.value, count: res.data.count });
            })
            .catch(e => {
                axiosErrorHandler(e, {
                    functionName: 'search',
                    requestName: 'search_anomaly',
                })
                this.setState({
                    loading: false,
                    message: e.response && e.response.data && e.response.data.error ? e.response.data.error : 'An error has occured.',
                    messageType: 'error'
                })
            })
    }

    delete = (id: number) => {
        if (window.confirm(`Are you sure you want to delete anomaly'${id}' ?`)) {
            request(`${API_URL}/api/v1/anomalies/${id}`, {
                method: 'delete',
                responseType: 'json',
                serializer: 'json'
            })
                .then((res: any) => {
                    this.search();
                })
                .catch(e => {
                    axiosErrorHandler(e, {
                        functionName: 'delete',
                        requestName: 'delete_anomaly',
                    })
                    this.setState({
                        loading: false,
                    })
                })
        }
    }
};

export default connect((state: any) => {
    return {
        general: state.general
    }
}, {
    setGeneral
})(DeletedAnomaliesSearch);